import React, { useEffect, useState } from 'react'
import { Dimmer,Loader,Segment } from 'semantic-ui-react';
import { getMarketActualCommissionRevenue, getCategoryActualCommissionRevenue } from 'services/Manager';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const ActualCommissionRevenueChart = ({ isOnFirstLevel,onARContainerClick, market, category,lastMonths,type}) => {

    const [dataLoading,setDataLoading] = useState(true);
    const [chartData,setChartData] = useState([]);

    useEffect(() => {
        loadData();
    } , [])

    let loadData = async () => {
        setDataLoading(true);      
        if(type == "market" && market && market.id)
        {
            let response = await getMarketActualCommissionRevenue(market.id,category ? category.id : undefined, lastMonths);
            if(response.resStatus == 200){
                setChartData(response.data)
            }
        }else if (type == "category" && category && category.id)
        {
            let response = await getCategoryActualCommissionRevenue(category.id, market ? market.id : undefined, lastMonths);
            if(response.resStatus == 200){
                setChartData(response.data)
            }
        }

        setDataLoading(false)
    }

    return (
        <div 
            className={`ar-container ${isOnFirstLevel() ? "" : "no-selection"}`} 
            onClick={isOnFirstLevel() ? () => { onARContainerClick(type == "market" ? market : category) } : () => { }} >
            <h2>
                {
                    type == "market" ? market.name : category.name
                }
            </h2>
            {
                dataLoading ? 
                <Dimmer.Dimmable as={Segment} dimmed={true}>
                    <Dimmer {...{
                        active: true,
                    }}>
                        <Loader inverted>Loading</Loader>
                    </Dimmer>
                </Dimmer.Dimmable>  :
                <ResponsiveContainer width="100%" height="100%">
                <LineChart
                    className={"commission-revenue-line-chart"}
                    data={chartData}
                    margin={{
                        top: 0,
                        right: 5,
                        left: 5,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis hide={true}
                    />
                    <Tooltip active={true} />
                    <Legend />
                    <Line type="monotone" dataKey="Charged" stroke="#056e07" />
                    <Line type="monotone" dataKey="Refunded" stroke="#990000" /> 
                    <Line type="monotone" dataKey="Disputed" stroke="#4000ff" /> 
                    <Line type="monotone" dataKey="Total" stroke="#a18d0d" />
                </LineChart>
                </ResponsiveContainer>
            }
        </div>
    )
}


export default ActualCommissionRevenueChart